var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 73,
    viewBox: "0 0 92 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5068_10741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0C4.58078 0 0.5 4.09199 0.5 9.125V36.5C0.5 41.533 4.58078 45.625 9.6 45.625H14.15V52.4688C14.15 53.3385 14.6334 54.1227 15.4013 54.5076C16.1691 54.8926 17.0933 54.807 17.79 54.2937L29.3214 45.625H50.55C55.5692 45.625 59.65 41.533 59.65 36.5V9.125C59.65 4.09199 55.5692 0 50.55 0H9.6ZM50.55 50.1875H36.9V54.75C36.9 59.783 40.9808 63.875 46 63.875H62.6786L74.21 72.5437C74.8925 73.057 75.8167 73.1426 76.5988 72.7576C77.3808 72.3727 77.85 71.5885 77.85 70.7188V63.875H82.4C87.4192 63.875 91.5 59.783 91.5 54.75V27.375C91.5 22.342 87.4192 18.25 82.4 18.25H64.2V36.5C64.2 44.0566 58.0859 50.1875 50.55 50.1875Z",
    fill: "#352750"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5068_10741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 73,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/Communication.0d81cbcc0971e43c8903d4ce7199d86e.svg";
export { ForwardRef as ReactComponent };